<template>
  <ul
    v-if="showDropdown && filteredTags.length"
    class="z-10 bottom-[calc(100%+10px)] left-0 absolute bg-white border rounded shadow-md mt-1 w-full p-2"
  >
    <li
      v-for="(tag, index) in filteredTags"
      :key="index"
      :class="{ 'bg-utility-gray-light-100': index === selectedDropdownIndex }"
      @mousedown.prevent
      @click="insertTagFromDropdown(tag.name)"
      class="relative flex w-full cursor-pointer select-none items-center rounded-sm py-1.5 px-2"
    >
      <SmartTag :label="tag.name" />
    </li>
  </ul>
</template>

<script setup>
import { SmartTag } from "@/Pages/Settings/MessengerFlow/Partials";

defineProps({
  showDropdown: Boolean,
  filteredTags: Array,
  selectedDropdownIndex: Number,
});

const emits = defineEmits(["selectTag"]);

const insertTagFromDropdown = (tag) => {
  emits("selectTag", tag);
};
</script>
